import { Button } from "antd";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import { useColumnsEquivalencySimulator } from "../hooks/useColumnsEquivalencySimulator";

const EquivalencyTable = ({ action, isLoading, state, title = "Assets" }) => {
    const dispatch = useDispatch();
    const { columns: columnsEquivalency, props: propsEquivalency } = useColumnsEquivalencySimulator(dispatch);

    return (
        <Fragment>
            <div className="md:w-1/5">
                <div className="flex justify-start items-center gap-2 mb-6 -mt-6">
                    <h3 className="text-[#282828] text-xs font-bold">{title}</h3>
                    <Button
                        className="bg-primaryTwo hover:bg-primaryTwoHover flex justify-center items-center mr-auto h-5 w-5"
                        type="primary"
                        onClick={action}
                        icon={<PlusOutlined className="text-xs flex" />}
                    />
                </div>
                <TableGeneral loading={isLoading} state={state} column={columnsEquivalency} tableProps={propsEquivalency} />
            </div>
        </Fragment>
    );
};

export default EquivalencyTable;
